var _path, _path2, _circle, _path3, _circle2, _circle3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioInputIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0151 0.835938H1.7193C0.972549 0.835938 0.367188 1.4413 0.367188 2.18805V23.4838C0.367188 24.2306 0.972549 24.8359 1.7193 24.8359H23.0151C23.7618 24.8359 24.3672 24.2306 24.3672 23.4838V2.18805C24.3672 1.4413 23.7618 0.835938 23.0151 0.835938Z",
    stroke: "#D9D9D9",
    strokeWidth: 0.333333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8698 19.5039H3.86979C3.77774 19.5039 3.70312 19.5785 3.70312 19.6706C3.70312 19.7626 3.77774 19.8372 3.86979 19.8372H20.8698C20.9618 19.8372 21.0365 19.7626 21.0365 19.6706C21.0365 19.5785 20.9618 19.5039 20.8698 19.5039Z",
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.70052,
    cy: 7.83333,
    r: 1.91667,
    stroke: "#4D4D4D",
    strokeWidth: 0.833333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0312 7.83203H17.6979",
    stroke: "#4D4D4D",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.70052,
    cy: 13.8333,
    r: 1.91667,
    stroke: "#4D4D4D",
    strokeWidth: 0.833333
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.70085,
    cy: 13.8337,
    r: 1.02117,
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0312 13.832H17.6979",
    stroke: "#4D4D4D",
    strokeWidth: 0.833333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioInputIcon);
export default __webpack_public_path__ + "static/media/radio-input-icon.ba573c866f9d2b68461d40d4948f1474.svg";
export { ForwardRef as ReactComponent };